import React from "react";
import { CFormGroup, CLabel, CCol, CSwitch } from "@coreui/react";
import { Controller } from "react-hook-form";

import ErrorInput from "../ErrorInput";
import "./styles.css";

function CustomCheckbok({
  name,
  control,
  required,
  errors,
  onSelect,
  defaultValue,
  placeholder,
  link,
  custom,
  ...props
}) {
  const invalid = (errors, name) => {
    return errors[name] ? true : false;
  };
  return (
    <CFormGroup row>
      <CCol xs="4" md={custom ? "4" : "2"} style={{ textAlign: "center" }}>
        <Controller
          rules={{ required }}
          control={control}
          name={name}
          defaultValue={defaultValue}
          render={(props) => (
            <CSwitch
              className={"mx-1"}
              shape={"pill"}
              color={"secondary"}
              onChange={(e) => props.onChange(e.target.checked)}
              checked={props.value}
            />
          )}
          {...props}
        />
      </CCol>
      <CCol xs="8" md={custom ? "8" : "10"}>
        <CLabel>
          {placeholder}
          {link && (
            <p onClick={link.func} className="link-text">
              {link.text}
            </p>
          )}
        </CLabel>

        {invalid(errors, name) && (
          <ErrorInput text="Este campo es obligatorio" />
        )}
      </CCol>
    </CFormGroup>
  );
}

export default CustomCheckbok;
